import { render, staticRenderFns } from "./CheckoutNowButton.vue?vue&type=template&id=1cbf5d85&"
import script from "./CheckoutNowButton.vue?vue&type=script&lang=js&"
export * from "./CheckoutNowButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CheckoutNowButton.vue"
export default component.exports